import { useWindowDimensions } from "@hooks/application";

export const useDynamicChartWidth = () => {
  const { width: windowWidth } = useWindowDimensions();

  const width = (() => {
    if (windowWidth < 400) {
      return 300;
    }

    if (windowWidth < 800) {
      return windowWidth * 0.8;
    }

    return windowWidth * 0.4;
  })();

  return { width };
};
